import Head from 'next/head';

import { GOOGLE_PUBLISHER_TAG_DEFAULTS } from './constants';

type NextGooglePublisherTagConfigProps = {
  adUnitPath?: string;
  slotId?: string;
  sizes?: [number, number];
};

export const NextGooglePublisherTagConfig = ({
  adUnitPath = GOOGLE_PUBLISHER_TAG_DEFAULTS.adUnitPath,
  slotId = GOOGLE_PUBLISHER_TAG_DEFAULTS.slotId,
  sizes = GOOGLE_PUBLISHER_TAG_DEFAULTS.sizes,
}: NextGooglePublisherTagConfigProps) => {
  if (process.env.NEXT_PUBLIC_ENABLE_GOOGLE_PUBLISHER_TAG !== 'true') {
    return null;
  }

  return (
    <Head>
      <script
        key="google-publisher-tag-script"
        async
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        crossOrigin="anonymous"
      />
      <script
        key="google-publisher-tag-init"
        dangerouslySetInnerHTML={{
          __html: `
            window.googletag = window.googletag || { cmd: [] };
            window.__gptServicesEnabled = window.__gptServicesEnabled || false;
            googletag.cmd.push(function () {
              var existingSlot = googletag
                .pubads()
                .getSlots()
                .find(function (slot) {
                  return slot.getSlotElementId && slot.getSlotElementId() === '${slotId}';
                });

              if (!existingSlot) {
                googletag
                  .defineSlot('${adUnitPath}', [${sizes[0]}, ${sizes[1]}], '${slotId}')
                  .addService(googletag.pubads());
              }

              if (!window.__gptServicesEnabled) {
                googletag.setConfig({ singleRequest: true });
                googletag.enableServices();
                window.__gptServicesEnabled = true;
              }
            });
          `,
        }}
      />
    </Head>
  );
};
